import { trainingprogram } from '../../../lib/apiList'
import axios from '../../../lib/axios'
import { AddTrainingProgram, TrainingPayload } from '../slice/type'

export const getAllPrograms = async () => {
    const data = {
        orderBy: ['CreatedOn desc'],
    }
    const response = await axios.post(trainingprogram.ADMINPROGLIST, data)
    return response
}

export const createProgram = async (data: AddTrainingProgram) => {
    const response = await axios.post(trainingprogram.CREATEPROGRAM, data)
    return response
}

export const delProgram = async (id: string) => {
    const response = await axios.delete(trainingprogram.DELPROGRAM, {
        data: { programId: id },
    })
    return response
}

export const editProgram = async (data: TrainingPayload) => {
    const response = await axios.put(trainingprogram.EDITPROGRAM, data)
    return response
}

export const getAssignedUsers = async (id: string) => {
    const response = await axios.get(`${trainingprogram.GETASSIGNEDUSERS}${id}`)
    return response
}

export const getLocBasedUsers = async (locid: string) => {
    const response = await axios.get(`${trainingprogram.LOCBASEDUSERS}${locid}`)
    return response
}

export const assignProgram = async (data: any) => {
    const response = await axios.post(`${trainingprogram.ASSIGNPROGRAM}`, data)
    return response
}

export const delAssignUser = async (programId: string, userId: string[]) => {
    const data = {
        programId: programId,
        userId: userId,
    }
    const response = await axios.delete(`${trainingprogram.DELASSIGNUSER}`, {
        data: data,
    })
    return response
}
